export const menuList = [
    {
        name: "SEARCH",
        access_type: null,
        icon: "search",
        subItems: [
            { name: "CONVERSATIONS", type: "react", Link: "/conversations/0" },
            { name: "INSIGHTS", type: "react", Link: "/insights/0" },
        ],
    },

    {
        name: "Tutorials",
        icon: "video",
        type: "react",
        Link: "/tutorials",
    },
    //Changed Twitter name to X
    {
        name: "PAGE ANALYTICS",
        icon: "facebookInsights",
        subItems: [
            { name: "FACEBOOK INSIGHTS", type: "react", Link: "/owned-page/facebook" },
            { name: "INSTAGRAM INSIGHTS", type: "react", Link: "/owned-page/instagram" },
            { name: "X INSIGHTS", type: "react", Link: "/owned-page/twitter" },
            { name: "TIKTOK INSIGHTS", type: "react", Link: "/owned-page/tiktok" },
            { name: "LINKEDIN INSIGHTS", type: "react", Link: "/owned-page/linkedin" },
            { name: "YOUTUBE INSIGHTS", type: "react", Link: "/owned-page/youtube" },
            { name: "COMPETITOR INSIGHTS", type: "react", Link: "/owned-page/competitor" },
        ],
    },

    {
        name: "OPA OVERVIEW",
        icon: "opaOverview",
        type: "react",
        Link: "/owned-page/overview",
    },
    {
        name: "FACEBOOK INSIGHTS",
        icon: "facebookIcon",
        type: "react",
        Link: "/owned-page/facebook",
    },
    {
        name: "INSTAGRAM INSIGHTS",
        icon: "instagramIcon",
        type: "react",
        Link: "/owned-page/instagram",
    },
    {
        name: "X INSIGHTS",
        icon: "twitterIcon",
        type: "react",
        Link: "/owned-page/twitter",
    },
    { name: "LINKEDIN INSIGHTS", icon: "linkedinIcon", type: "react", Link: "/owned-page/linkedin" },

    {
        name: "TIKTOK INSIGHTS",
        icon: "tiktokIcon",
        type: "react",
        Link: "/owned-page/tiktok",
    },
    { name: "YOUTUBE INSIGHTS", icon: "youtubeIcon", type: "react", Link: "/owned-page/youtube" },
    {
        name: "COMPETITOR INSIGHTS",
        icon: "facebookInsights",
        type: "react",
        Link: "/owned-page/competitor",
    },
    {
        name: "Listening",
        icon: "listening",
        type: "react",
        Link: "/dashboard/all",
    },
    {
        name: "Listening New",
        icon: "listening",
        type: "react",
        Link: "/downloads",
    },
    {
        name: "Page Analytics",
        icon: "pageAnalytics",
        type: "react",
        Link: "/owned-page",
    },
    {
        name: "Publishing",
        icon: "publish",
        type: "react",
        Link: "/social-media-publishing/create-post",
    },
    {
        name: "Response",
        icon: "response",
        type: "react",
        Link: "/social-response/inbox",
    },
    {
        name: "Create New",
        icon: "smpCreateNew",
        type: "react",
        Link: "/social-media-publishing/dashboard",
    },
    {
        name: "SMP Settings",
        icon: "settings",
        type: "react",
        Link: "/social-media-publishing/settings",
    },
    {
        name: "Asset Library",
        icon: "assetLibrary",
        type: "react",
        Link: "/social-media-publishing/assets",
    },
    {
        name: "SMP Dashboard",
        icon: "dashboard",
        type: "react",
        Link: "/social-media-publishing/analytics",
    },

    // { name: "FACEBOOK INSIGHTS", type: "react", Link: "/facebook-insights", icon: "facebookInsights" },
    {
        name: "TRENDS",
        icon: "trend",
        subItems: [
            { name: "X Trends", type: "react", Link: "/twitter-trends" },
            { name: "YouTube Trends", type: "react", Link: "/youtube-trends" },
        ],
    },
    {
        name: "Dashboard",
        icon: "dashboard",
        subItems: [
            { name: "All Dashboards", type: "react", Link: "/dashboard/all" },
            { name: "Standard Dashboards", type: "react", Link: "/dashboard/standard" },
            { name: "My Dashboards", type: "react", Link: "/dashboard/my" },
            { name: "Shared Dashboards", type: "react", Link: "/dashboard/shared" },
            { name: "Favorites", type: "react", Link: "/dashboard/favorites" },
            { name: "Trash", type: "react", Link: "/dashboard/trash" },
            // { name: "Recently Viewed", type: "react", Link: "/dashboard/recent" },
            // { name: "Command Center", type: "react", Link: "/dashboard/commandcenter" },
            // { name: "Drafts", type: "react", Link: "/dashboard/drafts" },
        ],
    },
    { name: "SMBDashboard", type: "react", icon: "dashboard", Link: "/dashboard/all" },

    { name: "Search", type: "react", Link: "/search", icon: "research" },
    { name: "COLLECTIONS", type: "react", Link: "/collections", icon: "collection" },
    { name: "DOWNLOADS", type: "react", Link: "/downloads", icon: "downloads" },
    {
        name: "Getting Started",
        type: "react",
        Link: "/gettingStarted",
        icon: "home",
    },
    {
        name: "Query Builder",
        type: "react",
        Link: "/data",
        icon: "data",
    },
    {
        name: "Query Builder",
        key: "Query Builder",
        icon: "data",
        subItems: [
            { name: "Query Builder", type: "react", Link: "/data/query-builder" },
            { name: "Instagram Hashtags", type: "react", Link: "/data/instagram-hashtags" },
            { name: "Historic Data", type: "react", Link: "/data/historic-data" },
        ],
    },
    {
        name: "Query Builder",
        key: "Query Builder",
        icon: "data",
        subItems: [
            { name: "Query Builder", type: "react", Link: "/data/query-builder" },
            { name: "Instagram Hashtags", type: "react", Link: "/data/instagram-hashtags" },
            { name: "Historic Data", type: "react", Link: "/data/historic-data" },
        ],
    },
    { name: "SMB Query Builder", type: "react", icon: "data", Link: "/data/query-builder" },

    {
        name: "Query Builder",
        key: "Query Builder Trial",
        icon: "data",
        subItems: [
            { name: "Query Builder", type: "react", Link: "/data/query-builder" },
            { name: "Instagram Hashtags", type: "react", Link: "/data/instagram-hashtags" },
        ],
    },
    {
        name: "BEACON",
        subItems: [
            { name: "CRISIS", type: "php", Link: "site/crisis" },
            { name: "QUERIES", type: "php", Link: "site/queries" },
            { name: "LEADS", type: "php", Link: "site/leads" },
        ],
    },
    { name: "REPORTS", type: "react", Link: "/reports", icon: "report" },
    { name: "ALERTS", type: "react", Link: "/alerts", icon: "alert" },
    // { name: "DATA USAGE", type: "react", Link: "/data-usage", icon: "datausage" },

    {
        name: "DATA USAGE",
        key: "DATA USAGE",
        icon: "datausage",
        subItems: [
            { name: "Overview", type: "react", Link: "/data-usage/overview" },
            { name: "Analytics", type: "react", Link: "/data-usage/analytics" },
        ],
    },
    {
        name: "SOCIAL TOKENS",
        icon: "socialtokens",
        type: "react",
        Link: "/social-tokens",
        // subItems: [
        //     { name: "Facebook Tokens", type: "react", Link: "/facebook-tokens" },
        //     { name: "Instagram Tokens", type: "react", Link: "/instagram-tokens" },
        //     // { name: "Linkedin", type: "react", Link: "/linkedin-tokens" },
        // ],
    },
    // { name: "Advanced Custom Chart", type: "react", Link: "/advanced-chart", icon: "datausage" },
];

export const opaWithoutYT = {
    name: "PAGE ANALYTICS",
    icon: "facebookInsights",
    subItems: [
        { name: "FACEBOOK INSIGHTS", type: "react", Link: "/owned-page/facebook" },
        { name: "INSTAGRAM INSIGHTS", type: "react", Link: "/owned-page/instagram" },
        { name: "X INSIGHTS", type: "react", Link: "/owned-page/twitter" },
        { name: "TIKTOK INSIGHTS", type: "react", Link: "/owned-page/tiktok" },
        { name: "LINKEDIN INSIGHTS", type: "react", Link: "/owned-page/linkedin" },
        // { name: "YOUTUBE INSIGHTS", type: "react", Link: "/owned-page/youtube" },
        { name: "COMPETITOR INSIGHTS", type: "react", Link: "/owned-page/competitor" },
    ],
};
export const settingsMenu = {
    name: "SETTINGS",
    icon: "settings",
    subItems: [
        // { name: "VIRALITY THRESHOLD", type: "react", Link: "/settings/virality-threshold" },
        { name: "BLOCK SOURCE", type: "react", Link: "/settings/block-source", packageFeature: ["enterprise"] },
        { name: "FILTERS", type: "react", Link: "/settings/filters" },
        // { name: "SPAM", type: "react", Link: "/settings/spam" },
        { name: "WORDCLOUD", type: "react", Link: "/settings/wordcloud", packageFeature: ["enterprise"] },
        { name: "USER MANAGEMENT", type: "react", Link: "/settings/user-management" },
        // { name: "PUBLICATION", type: "react", Link: "/settings/publications" },
        // { name: "FACEBOOK COMMENTS", type: "react", Link: "/settings/facebook-comments" },
        // { name: "INSTAGRAM HASHTAGS", type: "react", Link: "/settings/instagram-hashtags" },
        // { name: "LOGIN LOGS", type: "react", Link: "/settings/login-logs", packageFeature: ["enterprise", "free"] },
        // { name: "LOGIN LOGS", type: "react", Link: "/settings/login-logs", packageFeature: ["enterprise"] },
        { name: "ACTIVITY LOGS", type: "react", Link: "/settings/activity-logs" },
        { name: "Logo", type: "react", Link: "/settings/logo-upload" },
        { name: "Image Analytics", type: "react", Link: "/settings/image-analytics", packageFeature: ["enterprise"] },
    ],
};
export const userSettings = {
    name: "SETTINGS",
    icon: "settings",
    subItems: [
        { name: "USER MANAGEMENT", type: "react", Link: "/settings/user-management" },
        { name: "ACTIVITY LOGS", type: "react", Link: "/settings/activity-logs" },
        { name: "Logo", type: "react", Link: "/settings/logo-upload" },
    ],
};

export const smrLists = [
    { name: "SMR Settings", type: "react", Link: "/social-response/settings", icon: "settings" },
    { name: "SMR Inbox", type: "react", Link: "/social-response/inbox", icon: "smr" },
    { name: "SMR Reports", type: "react", Link: "/social-response/reports", icon: "report" },
    { name: "SMR Analytics", type: "react", Link: "/social-response/analytics", icon: "facebookInsights" },
    { name: "SMR Dashboard", type: "react", Link: "/social-response/dashboard", icon: "facebookInsights" },
    { name: "SMR Canned Response", type: "react", Link: "/social-response/canned", icon: "cannedResponse" },
    { name: "Integrations", type: "react", Link: "/social-response/integrations/salesforce", icon: "integrationIcon" },
    { name: "SMR Filters", type: "react", Link: "/social-response/filters", icon: "filterIcon" },
    { name: "SMR Survey", type: "react", Link: "/social-response/survey", icon: "surveyIcon" },
    { name: "Keyword Based Sync", type: "react", Link: "/social-response/keyword-synced-tickets", icon: "data" },
];
export const smrWithSettingswithoutAnalytics = {
    name: "Social Media Response",
    icon: "smr",
    subItems: [
        { name: "SMR Settings", type: "react", Link: "/social-response/settings" },
        { name: "SMR Inbox", type: "react", Link: "/social-response/inbox" },
    ],
};
export const smrWithSettings = {
    name: "Social Media Response",
    icon: "smr",
    subItems: [
        { name: "SMR Settings", type: "react", Link: "/social-response/settings" },
        { name: "SMR Filters", type: "react", Link: "/social-response/filters" },
        { name: "SMR Inbox", type: "react", Link: "/social-response/inbox" },
        { name: "SMR Analytics", type: "react", Link: "/social-response/dashboard" },
        { name: "SMR Canned Response", type: "react", Link: "/social-response/canned" },
        { name: "Integrations", type: "react", Link: "/social-response/integrations/salesforce" },
        //  { name: "SMR Integrations", type: "react", Link: "/social-response/integrations" },
    ],
};
export const smrWithSettingswithoutFilters = {
    name: "Social Media Response",
    icon: "smr",
    subItems: [
        { name: "SMR Settings", type: "react", Link: "/social-response/settings" },
        { name: "SMR Inbox", type: "react", Link: "/social-response/inbox" },
        { name: "SMR Analytics", type: "react", Link: "/social-response/dashboard" },
        { name: "SMR Canned Response", type: "react", Link: "/social-response/canned" },

        // { name: "SMR Integrations", type: "react", Link: "/social-response/integrations" },
    ],
};
export const smrWithoutSettings = {
    name: "Social Media Response",
    icon: "smr",
    subItems: [{ name: "SMR Inbox", type: "react", Link: "/social-response/inbox" }],
};

export const publishingWithSettings = {
    name: "Social Media Publishing",
    icon: "smp",
    subItems: [
        { name: "SMP Dashboard", type: "react", Link: "/social-media-publishing/dashboard" },
        { name: "SMP Settings", type: "react", Link: "/social-media-publishing/settings" },
        { name: "Asset Library", type: "react", Link: "/social-media-publishing/assets" },
    ],
};

export const publishingWithoutSettings = {
    name: "Social Media Publishing",
    icon: "smp",
    subItems: [
        { name: "SMP Dashboard", type: "react", Link: "/social-media-publishing/dashboard" },
        // { name: "SMP Settings", type: "react", Link: "/social-media-publishing/settings" },
        { name: "Asset Library", type: "react", Link: "/social-media-publishing/assets" },
    ],
};

// export const subscriptionSettings = {
//     name: "Subscription",
//     icon: "dashboard",
//     subItems: [
//         { name: "Plans", type: "react", Link: "/subscription/plans" },
//         { name: "History", type: "react", Link: "/subscription/history" },
//     ],
// };

export const subscriptionSettings = {
    name: "Subscription",
    icon: "subscription",
    subItems: [
        { name: "Plans", type: "react", Link: "/billing/plans" },
        { name: "Addons", type: "react", Link: "/billing/addons" },
        { name: "History", type: "react", Link: "/billing/history" },
    ],
};

export const subscriptionSettingsWithPlansOnly = {
    name: "Subscription",
    icon: "subscription",
    subItems: [{ name: "Plans", type: "react", Link: "/billing/plans" }],
};

export const menuLinks = [
    "conversations",
    "insights",
    "custom-dashboard",
    "facebook-insights",
    "twitter-trends",
    "youtube-trends",
    "collections",
    "downloads",
    "data",
    "facebook-comments",
    "reports",
    "alerts",
    "data-usage",
    "facebook-tokens",
    "instagram-tokens",
    "settings",
    "dashboard",
    "research",
    "social-response",
    "social-media-publishing",
    "billing",
    "owned-page",
];

export const modules = [
    //arr[0]= moduleName, arr[1]= icon
    ["Listening", "listening"],
    ["Publishing", "publish"],
    ["Response", "response"],
    ["Page Analytics", "pageAnalytics"],
    ["Command Center", "commandCenter"],
];

export const gettingStartedLists = [
    {
        module: "Listening",
        name: "Getting Started",
        type: "react",
        Link: "/listening/getting-started",
        icon: "home",
    },
    {
        module: "Publishing",
        name: "Getting Started",
        type: "react",
        Link: "/publishing/getting-started",
        icon: "home",
    },
    {
        module: "Response",
        name: "Getting Started",
        type: "react",
        Link: "/response/getting-started",
        icon: "home",
    },
    {
        module: "Page Analytics",
        name: "Getting Started",
        type: "react",
        Link: "/page-analytics/getting-started",
        icon: "home",
    },
];
